export default {
  // INCREASE_UPDATE_COUNT(state) {
  //   state.stateUpdateCounter = state.stateUpdateCounter + 1;
  // },

  // SET_VIEW_RANGE_START(state, value) {
  //   state.view.range_start = value;
  // },
  //
  // SET_VIEW_HORIZON(state, value) {
  //   state.view.horizon = value;
  // },

  SET_WEEKDAY_PREF_FLAT_CACHE(state, { id, weekday_preferences_flat }) {
    state.cache.timeslot_flat_cache[id] = weekday_preferences_flat;
  },

  SET_TIMESLOT_CACHE(state, data) {
    state.cache.timeslot_flat_cache = data
  },

  RESET(state) {
    state.stateUpdateCounter = 0;
    state.cache.timeslot_flat_cache = {};
  },
};
